<template>
  <section
    class="slide sec3 whiteSlide kenBurns bg-white overflow-hidden opacity-0 fixed w-full h-full text-black"
  >
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap cursor-default table-cell align-middle">
          <div class="fix-width max-w-1114px ml-auto mr-auto">
            <ul class="grid sec-details sec-details2 ml-spc16 mr-spc16">
              <li
                class="col-6-12 mt-spc13 max-w-589 w-full pl-6 pr-6 block text-center"
                id="productImage1"
              >
                <SliderOne :slideDatas="mjSliderData" />
              </li>
              <li class="col-6-12 left max-w-589 w-full pl-6 pr-6 block">
                <SectionDetailsContent
                  :title="title"
                  :sizes="sizes"
                  :prices="prices"
                  :colors="colors"
                  :fabrics="fabrics"
                  btn1title="Purchase"
                  btn2title="Enquiries"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SliderOne from "../sliders/slider1/SliderOne";
import SectionDetailsContent from "../common/SectionDetailsContent";

let mjSliderData = {
  sliderID: "31",
  mjSliders: [
    {
      active: true,
      img: require("@/assets/images/products/thumbblacksheep1.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbblacksheep2.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbblacksheep3.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbblacksheep4.png")
    }
  ]
};

export default {
  name: "Section10",
  components: {
    SectionDetailsContent,
    SliderOne
  },
  data: function() {
    return {
      mjSliderData,
      title: "THE BLACK SHEEP",
      sizes: {
        sticks: "1, 4, 6 or 8 Sheep"
      },
      colors: {
        clr: "Natural Variations “Cochddu” C",
        clr2: "Thomas Weaver 1831 (Blue)",
        clr3: "B R. Whitford 1859 (Green) G"
      },
      fabrics: {
        fabric: "Natural Sheepskin"
      },
      prices: {
        price1: "$640 for single sheep (other sizes priced individually)",
        price2: "Allow up to 52 weeks delivery for multi-sheep items"
      }
    };
  }
};
</script>

<style scoped>
</style>